import { useCallback, useEffect, useState } from 'react';
import { usePlanEntitlements } from '../../providers/PlanEntitlementsProvider';
import { fetchMyOrganizations } from '../organizationSwitcherService';

export function useOrganizationSwitcherAccess() {
  const { entitlements } = usePlanEntitlements();
  const isOwner = entitlements?.is_owner === true;
  const [orgCount, setOrgCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await fetchMyOrganizations();
      setOrgCount(payload?.organizations.length ?? 0);
    } catch {
      setOrgCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  /** Varios negocios: cambiar org activa. */
  const canSwitchOrganization = orgCount > 1;
  /** Dueño puede abrir el sheet aunque tenga un solo negocio (agregar otro local). */
  const canOpenOrganizationMenu = canSwitchOrganization || isOwner;

  return {
    canSwitchOrganization,
    canOpenOrganizationMenu,
    organizationCount: orgCount,
    loading,
    refresh,
  };
}
